import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=52f280fc&scoped=true&lang=css"

import exportComponent from "/home/xs909715/manage-sys.net/deploy/call-center-fe/production/releases/5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f280fc"]])

export default __exports__